import routes from './routes';
import { SetRoutes } from 'components';

const EmergencyContactsPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default EmergencyContactsPages;
